const TRANSFERVIEW = {
  transferFormsCompany: "Transferencia de formularios entre compañías.",
  search: "Bucar...",
  addDescription: "Agregar descripción",
  editTask: "Editar tarea",
  originCompany: "Compañía de origen",
  destinityCompany: "Compañía de destino",
  group: "grupo",
  toTransfer: "Transferir",
  transfer: "Transferencia",
  successTransfer: "Se ha realizado la trasferencia del formulario.",
  form: "Formulario",
  typeForm: "Tipo de formulario",
  group: "Grupo",
  Active: "Activo",
  Closed: "Inactivo",
  Deleted: "Eliminado"
};

export default { TRANSFERVIEW };
